// import { createStore, applyMiddleware } from "redux";
// import reduxThunk from "redux-thunk";
// import rootReducer from '../reducers/index';

// const logger = store => next => action =>{
    
//     let result = next(action)
    
//     return result
// }

// const createStoreWithMiddleware = applyMiddleware(logger,reduxThunk)(createStore);

// const store = createStoreWithMiddleware(rootReducer);

// export default store;

/**
 * Create the store with dynamic reducers
 */

import { createStore, applyMiddleware, compose } from 'redux';
import { fromJS } from 'immutable';
import reduxThunk from "redux-thunk";
// import { persistStore, autoRehydrate } from 'redux-persist-immutable';
import history from '../memoryHistory';
// import { combineReducers } from 'redux-immutable';
// import createSagaMiddleware from 'redux-saga';
// import createReducer from './reducers';
import rootReducer from '../reducers/index';
import { ConnectedRouter, routerReducer, routerMiddleware, push } from 'react-router-redux'

// Create a history of your choosing (we're using a browser history in this case)
// const history = createHistory()

// Build the middleware for intercepting and dispatching navigation actions
// const middleware = routerMiddleware(history)

const logger = store => next => action =>{
    
  let result = next(action)
  
  return result
}

const middlewares = [
  logger,
  routerMiddleware(history),
];

// Add the reducer to your store on the `router` key
// Also apply our middleware for navigating
const store = createStore(
  rootReducer,
  applyMiddleware(...middlewares,reduxThunk)
)

export default store;